import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=bc749c10&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc749c10')) {
      api.createRecord('bc749c10', component.options)
    } else {
      api.reload('bc749c10', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=bc749c10&", function () {
      api.rerender('bc749c10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MjoHutwhclwN/JS/comp/IncreaseNumber.vue"
export default component.exports